<template>
	<div class="equipmentInstallationManagement mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">设备管理</div>
		</div>
		<div class="mainBot ">
			<div class="contentTop" >
				<statisticalAnalysis></statisticalAnalysis>
			</div>
			<div class="contentBot" >
				<chargingRecord  @goUrl="goUrl"></chargingRecord>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import chargingRecord from "./chargingRecord/chargingRecord.vue"
	import statisticalAnalysis from "./statisticalAnalysis/statisticalAnalysis.vue"
	export default {
		name: "equipmentInstallationManagement",
		components: {
			chargingRecord,
			statisticalAnalysis
		},
		data() {
			return {
				mainUser:0
			}
		},
		mounted() {
			this.mainUser=localStorage.getItem('mainUser')||0
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			getData() {},
			goUrl(obj,str){
				this.$router.push({path: str,query:obj});
				this.$emit("setPath",str)
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./equipmentInstallationManagement.scss";
</style>
